
<template>
  <div
    v-else
    class="your-msg"
  >
    <div class="media">
      <img
        class="img-50 img-fluid m-r-20 rounded-circle"
        alt=""
        :src="getPhoto(comment.user.photo,'thumbnailCropped')"
      >
      <div class="media-body bg-white">
        <div class="d-flex justify-content-between align-items-top mb-3">
          <span class="f-w-600">
            {{ comment.user.name }} {{ comment.user.surname }} <br>
            <span class="text-primary">
              {{ comment.company.name }} {{
                getCompanyFormat(comment.company.format)
              }}
              ({{ comment.position }})
            </span>
          </span>
          <em class="text-secondary">
            {{ $t('dashboardCompany.key', {moment: getMoment(comment.logTime)}) }}
          </em>
        </div>

        <div
          v-if="comment.private"
          class="text-danger"
        >
          {{ $t('commentView.buRhGizlidir') }}
        </div>
        <div style="white-space: pre-wrap">
          {{ comment.commentText }}
        </div>

        <a
          v-if="comment.photo"
          :href="getPhoto(comment.photo,'')"
          target="_blank"
        >
          <img
            v-if="isPhoto(comment.photo)"
            :src="getPhoto(comment.photo,'thumbnailCropped')"
            style="max-height: 300px; max-width: 100%;"
            class="img-thumbnail"
            alt="-"
          >
          <div v-else>
            <button class="btn btn-outline-primary">
              {{ $t('commentView.faylYkl', {pop: comment.photo.split('.').pop()}) }}
            </button>
          </div>
        </a>

        <div
          v-if="isMyRequest && comment.user.id !== user.id "
          class="mt-2"
        >
          <router-link
            v-if="conversation"
            :to="`/dashboard/conversation/${conversation.id}`"
            class="btn btn-sm btn-primary"
          >
            <span v-if="conversation.open">{{ $t('commentView.mzakiryDavamEt') }}</span>
            <span v-else>{{ $t('commentView.mzakiryBax') }}</span>
          </router-link>
          <button
            v-else
            class="btn btn-sm btn-outline-primary"
            @click="startConversation"
          >
            {{ $t('commentView.mzakiryBala') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapState} from "vuex";
import {startConversation} from "@/repositories/GeneralDataRepository";
import {getCompanyFormat, getPhoto} from "@/repositories/Utils";
import moment from "moment";

export default {
  name: 'CommentView',
  props: {
    comment: {},
    isMyRequest: {},
    conversations: {}
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      token: state => state.auth.token,
    }),

    conversation(){
      let list = this.conversations.filter(conversation => this.comment.user.id === conversation.user.id && this.comment.company.id === conversation.company.id && this.comment.profileType === conversation.profileType);
      if(list.length>0){
        return list[0];
      }
      else  return  null;
    }
  },
  methods:{
    getMoment(time){
      moment.locale(this.$i18n.locale);
      return moment(new Date(time)).format('DD MMM YYYY HH:mm')
    },
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },
    getPhoto(path, size, defaultPhoto) {
      return getPhoto(path, size, defaultPhoto);
    },

    isPhoto(path) {
      return ['jpg', 'png', 'gif', 'jpeg'].indexOf(path.toLowerCase().split('.').pop()) > -1;
    },


    startConversation() {

      startConversation(this.token, this.comment.id).then(data => {

        if (data.code === 200) {
          this.$router.push(`/dashboard/conversation/${data.id}`);
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          }).then(() => {
            window.location.reload();
          })
        }

      });
    },
  }
}
</script>
